import { useEffect, useState } from "react";
import {
	detectAvailableRoles,
	determineCombinedFlow,
	getRecipientType,
} from "./flow-detector";
import { getActiveFlow } from "./flow-rules";
import { TransactionTypes } from "./flow-types";

const useFlowDetection = (
	dataElement,
	currentSelections = {},
	identity = null,
	transactionType = TransactionTypes.PUSH_STORE
) => {
	const [flowInfo, setFlowInfo] = useState(null);

	const {
		recipient = null,
		onBehalfOf = null,
		myPrincipals = null,
	} = currentSelections;

	useEffect(() => {
		if (!dataElement) {
			setFlowInfo(null);
			return;
		}

		const availableRoles = detectAvailableRoles(dataElement, identity);
		const combinedFlow = determineCombinedFlow(availableRoles);

		const recipientType = recipient ? getRecipientType(recipient[0]) : null;

		const selections = {
			recipient: recipient?.[0]
				? { ...recipient[0], type: recipientType }
				: null,
			onBehalfOf: onBehalfOf?.[0] || null,
			myPrincipals: myPrincipals || null,
		};

		// Calculate active flow
		const activeFlow = getActiveFlow(
			combinedFlow,
			selections,
			identity,
			transactionType
		);

		setFlowInfo({
			availableRoles, // Available roles
			combinedFlow, // Combined flow
			activeFlow // Currently active flow
		});
	}, [dataElement, recipient, onBehalfOf, myPrincipals, identity]);
	return flowInfo;
};

export default useFlowDetection;
